import { Injector, Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Store } from '@ngrx/store';
import { RecipeFormValues } from '@ordersnproducts/modules/order-builder/modules/retail-specification/models/form-values';
import { State } from '@ordersnproducts/modules/order-builder/modules/specification/reducers/specification/product-unit.reducer';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { getOneValidatedPurchaseOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-purchase-order-selector';

@Injectable()
export class OneClickPurchaseOrderValidator {
  static validator(store: Store<State>, currentItem: RecipeFormValues, injector: Injector): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
      const success = 'S';
      return store.select(getOneValidatedPurchaseOrder).pipe(
        filter(purchaseOrderValidated => purchaseOrderValidated !== null),
        take(1),
        map(purchaseOrderValidated => {
          if (purchaseOrderValidated.hasOwnProperty('messageType')) {
            return purchaseOrderValidated['messageType'] === success ? null : { purchaseOrderInvalid: true };
          }
          return null;
        }),
      );
    };
  }
}
